import React, { Component } from "react";
import { Modal } from "antd";
import { connect } from "react-redux";
import { closeModal } from "./modalActions";
import BulkOrderForm from "../bulkOrder/BulkOrderForm";

class BulkOrderModal extends Component {
  render() {
    const { closeModal } = this.props;
    return (
      <Modal
        title="Create Bulk Order"
        visible={true}
        onCancel={closeModal}
        footer={null}
        width={640}
        destroyOnClose
        centered
        className="bulk-order-modal"
      >
        <BulkOrderForm />
      </Modal>
    );
  }
}

const actions = { closeModal };

export default connect(null, actions)(BulkOrderModal);
